var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgRepeat = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 284,
    height: 284,
    viewBox: "0 0 284 284",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M208 88.4C205.6 87.3 202.7 87.7 200.7 89.5L191.4 97.8C178.7 82.8 160 74.2 140.4 74.2C102.7 74.2 72.1 104.7 72.1 142.4C72.1 180.1 102.6 210.7 140.3 210.7C169.2 210.7 195.1 192.5 204.7 165.2C205.9 161.6 204.1 157.7 200.5 156.5C196.9 155.3 193 157.1 191.8 160.7C181.7 189.1 150.5 204 122.1 193.9C93.7 183.8 78.8 152.6 88.9 124.2C96.6 102.4 117.3 87.8 140.4 87.8C156.2 87.8 171.1 94.7 181.3 106.8L170 116.8C167.9 118.7 167.1 121.7 168.2 124.4C169.2 127 171.7 128.8 174.5 128.8H205.2C209 128.8 212 125.7 212 122V94.6C212 91.9 210.4 89.5 208 88.4Z",
    fill: "black"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgRepeat, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/repeat.a4c8f359.svg";
export { ForwardRef as ReactComponent };